// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__35u7k","addWidgetButton":"Header_addWidgetButton__DJaAp","dashboardTabs":"Header_dashboardTabs__RpJ1k","active":"Header_active__OD4E1"};